// eslint-disable-next-line unicorn/prefer-node-protocol
import { Buffer } from 'buffer'

export { Buffer }
export default Buffer
